<mat-card class="dm__card">
  <p8-layout-settings-header [titlePath]="['Ajout d\'une liste de sollicités pour avis']"></p8-layout-settings-header>
  <mat-dialog-content>
    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>Nom de la liste</mat-label>
      <input [(ngModel)]="name"
             matInput
             matTooltip="Nom de la liste (5 cars. minimum)"
             placeholder='Nom de la liste (5 cars. minimum)'
             maxlength="{{MAX_LENGTH_NAME}}"
             type="text">
      <mat-hint align="end"><code>{{name?.length}}</code> / <code>{{MAX_LENGTH_NAME}}</code></mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button (click)="dialogRef.close()"
            mat-raised-button
            color="primary"
            type="button">
      Annuler
    </button>
    <button mat-raised-button
            cdkFocusInitial
            color="accent"
            (click)="createList()"
            [disabled]="!name || name.length < MIN_LENGTH_NAME || name.length > MAX_LENGTH_NAME">
      Créer
    </button>
  </mat-dialog-actions>
</mat-card>
